module.exports = __webpack_public_path__ + "img/Steor-Icons-12.6e6162ff.svg";